import { ReturnSteps } from 'app/constants';

export const constructURL = (route: string, hasGeo: boolean) => {
  const path = route !== ReturnSteps.LocateOrder ? '/return/' + route : route;

  return hasGeo ? path : path + '?in_geo=false';
};
